import React, { useContext } from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import { LAYOUT_BOX } from 'config/constants/ui'
import { useOrganization } from 'src/core/graphql/hooks'
import EventDetailsBlock from 'src/sites/kits/Events/components/DetailsBlock'
import MetadataBlock from 'src/sites/kits/Initiative/components/MetadataBlock'
import GithubIssueBlock from 'src/sites/kits/Integrations/components/GithubIssueBlock'
import GNS3DiscussionAdBanner from 'src/sites/custom/gns3/Banners/DiscussionAd'
import { InitiativeHierarchyContext } from 'src/sites/kits/Utils/InitiativeHierarchy'
import { useGlobalState } from 'src/sites/state'
import PeopleBlock from './PeopleBlock'
import SpecialPermissionsBlock from './SpecialPermissionsBlock'

const ObjectViewAside = ({ width }) => {
   const { theme } = useGlobalState()
   const { organization } = useOrganization()
   const { initiative } = useContext(InitiativeHierarchyContext)
   const isBoxGL = theme.tmpGlobalLayout === LAYOUT_BOX

   return (
      <View
         display={isBoxGL ? 'none[a-d] block[e-f]' : 'none[a-c] block[d-f]'}
         flex="0 0 auto"
         width={`100%[a-c] ${width}[d-f]`}
         paddingLeft="30px"
         paddingBottom="60px"
         paddingTop="40px"
         minHeight="100vh"
         borderLeft={isBoxGL
            ? `1px solid ${theme.tmpColumnBorderColor}[e-f]`
            : `1px solid ${theme.tmpColumnBorderColor}[d-f]`}>
         {initiative.class === 'event' && <EventDetailsBlock />}
         {['discussion', 'post', 'resource'].includes(initiative.class) && (
            <MetadataBlock />
         )}
         {initiative.class === 'group' && <PeopleBlock />}
         {initiative.hasInitiativeTypePolicies && <SpecialPermissionsBlock />}
         {organization.slug === 'gns3' && (
            <GithubIssueBlock />
         )}
         {organization.slug === 'gns3' && (
            <View width="100%" marginBottom="20px">
               <GNS3DiscussionAdBanner />
            </View>
         )}
      </View>
   )
}

ObjectViewAside.propTypes = {
   width: PropTypes.string.isRequired
}

export default ObjectViewAside
